import BaseModel from '../core/BaseModel'
import SetUpTermModel from '@/models/SetUpTermModel'
import ShowroomModel from '@/models/ShowroomModel'
export default class RentalOrderCustomModel extends BaseModel {

    constructor() {
        super({
                name: "rental_order_custom",
                tableName: 'rental_order',
                label: "Rental Order",
                display_key: 'code'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },

                code: {
                    name: 'code',
                    type: "String",
                    label: 'Order ID',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                list_contract_id: {
                    name: 'list_contract_id',
                    type: "String",
                    label: 'Contract ID',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },

                rent_license_plate_number: {
                    name: 'rent_license_plate_number',
                    type: "String",
                    label: 'License plate number',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                //Vehicle Category
                rent_vehicle_category_name: {
                    name: 'rent_vehicle_category_name',
                    type: "String",
                    label: 'Vehicle Category',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                post_id: {
                    name: 'post_id',
                    type: "String",
                    label: 'Post ID',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                fullname: {
                    name: 'fullname',
                    type: "String",
                    label: 'User',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                rent_contact_name: {
                    name: 'rent_contact_name',
                    type: "String",
                    label: 'Contact name',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                rent_contact_phone: {
                    name: 'rent_contact_phone',
                    type: "String",
                    label: 'Phone number',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                rent_valid_until_text: {
                    name: 'rent_valid_until_text',
                    type: "String",
                    label: 'Valid until',
                    class:"small-col-midle txt-left",
                    filter: { type: 'DateRange', match: 'equals' }
                  },
                  rent_term_id: {
                    name:'rent_term_id',
                    label:'Term',
                    type: "Selection",
                    custom: 'SelectionText',
                    models: new SetUpTermModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class:"small-col txt-left",
                    computed: (data) => {
                        data.rent_renter_id = '';
                    },
                },
                showroom_id: {
                    name:'showroom_id',
                    label:'Showroom',
                    type: "Selection",
                    custom: 'SelectionText',
                    models: new ShowroomModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class:"small-col txt-left",
                    computed: (data) => {
                        data.showroom_id = '';
                    },
                },
                rent_pick_up_date_text: {
                    name: 'rent_pick_up_date_text',
                    type: "String",
                    label: 'Pickup date',
                    class:"small-col-midle txt-left",
                    filter: { type: 'DateRange', match: 'equals' }
                  },
                  booking_status: {
                    name: "booking_status",
                    label: "Rental status",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        //gắn option tương tứng với value của booking_status
                        {value: 'TEMP_RENT', label: 'Draft orders', style: 'color:  #000000;'},
                        {value: 'BOOKED_RENT', label: 'Booked', style: 'color:  #000000;'},
                        {value: 'RENTING_RENT', label: 'Renting',style: 'color:  #000000;'},
                        {value: 'COMPLETED_RENT', label: 'Completed',style: 'color:  #000000;'},
                        {value: 'CANCEL_RENT', label: 'Cancelled',style: 'color:  #000000;'},
                        {value: 'CLOSING_RENT', label: 'Closing',style: 'color:  #000000;'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center txt-xs-col txt-left",
                },
                  source: {
                    name: "source",
                    label: "Source",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'WEB', label: 'Website', style: 'color:  #000000;'},
                        {value: 'IOS', label: 'Ios',style: 'color:  #000000;'},
                        {value: 'ANDROID', label: 'Android',style: 'color:  #000000;'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center txt-xs-col txt-left",
                },
                updated_by_key: {
                    name: 'updated_by_key',
                    type: "String",
                    label: 'Updated by',
                    class:"small-col-midle txt-left",
                    width: 15,
                  //  filter: {type: 'input', match: 'contains'},
                },
                updated_at : {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    class:"small-col-midle txt-left",
                   // filter: { type: 'DateRange', match: 'contains'}
                },
                is_block_auto_renew_contract_mail_push: {
                    name: "is_block_auto_renew_contract_mail_push",
                    label: "Block auto renew contract mail / push",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true',  label: 'Blocked', style: 'color:#000000;' },
                        { value: 'false', label: 'Allowed', style: 'color:#000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "center",
                },
                is_warning: {
                    name: "is_warning",
                    label: "Warning",
                    type: "Selection",
                    custom: 'SelectionText',
                    class:"small-col-midle  txt-left",
                    options: [
                        { value: true, label: 'Yes', style: 'color:  #000000;' },
                        { value: false, label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    width: 8,
                },

            })
    }

}